import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { MoveData } from '@app/move/classes/move-data.class';
import { MoveSandbox } from '@app/move/sandboxes/move.sandbox';
import { AppNavigationSandbox } from '@app/navigation/sandboxes/navigation.sandbox';
import { contactDetailsLeaverRoute } from '@app/energy-contract/energy-contract.constants';

@Component({
    selector: 'app-eots-success-container',
    template: `
        <app-card-container class="u-flex-row u-flex-justify-content-center">
            <div class="u-container">
                <app-card *ngIf="!!(move$ | async)" class="u-flex-row u-flex-justify-content-center">
                    <div *ngSwitchDefault class="u-flex-column u-flex-align-items-center u-container-small u-margin-bottom-double">
                        <img width="200" src="assets/images/smooved-energy-bulb.png" class="u-margin-bottom-double" />
                        <p class="u-font-size-medium u-text-align-center">
                            {{ 'REAL_ESTATE_AGENT.OTS.SUCCESS.TEXT_ENERGY' | translate }}
                        </p>
                    </div>

                    <app-button (click)="onNext()">{{ 'NEXT' | translate }}</app-button>
                </app-card>
            </div>
        </app-card-container>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuccessContainer extends MoveData implements OnInit {
    constructor(
        private route: ActivatedRoute,
        public moveSandbox: MoveSandbox,
        public navigationSandbox: AppNavigationSandbox,
        private router: Router,
    ) {
        super(moveSandbox, null);
    }

    public ngOnInit(): void {
        this.moveSandbox.idOnce$.subscribe((id) => {
            if (!id) {
                this.navigationSandbox.goToHome().then();
            } else {
                this.fetch(id);
            }
        });
    }

    public onNext(): void {
        const extras: NavigationExtras = {
            relativeTo: this.route,
        };

        extras.queryParams = {
            ...extras.queryParams,
            eots: true,
        };

        void this.router.navigate([contactDetailsLeaverRoute], extras).then();
    }
}
